import { render, staticRenderFns } from "./OrderErrorComponent.vue?vue&type=template&id=71f50fee"
import script from "./OrderErrorComponent.vue?vue&type=script&lang=js"
export * from "./OrderErrorComponent.vue?vue&type=script&lang=js"
import style0 from "./OrderErrorComponent.vue?vue&type=style&index=0&id=71f50fee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports